export const CATALOG_FILTERS_SUBCOLLECTION = 'catalogFilters';
